import { PredictionRegionList } from 'modules/Predictions/components/PredictionRegionList';
import { PredictionViewCore } from 'modules/Predictions/components/PredictionViewCore';
import { PredictionMediaList } from 'modules/ModelViewer/components/PredictionMediaList';
import { FC, useEffect } from 'react';
import { useUnsafePredictionStore } from 'modules/Predictions/contexts/MstPredictionStoreCtx';
import { IModelPredictionStoreMST } from 'modules/Predictions/mst/ModelPredictionStore';
import { useField } from 'formik';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { useModelContext } from 'modules/Models/components/ModelContext/ModelContext';
import { useEditableModel } from 'modules/Models/components/ModelViewer/useEditableModel';

interface PredictionViewProps {
  userAndAppIds?: { appId: string; userOrOrgId: string };
  disableRouterUpdates?: boolean;
}

export const PredictionView: FC<PredictionViewProps> = ({ userAndAppIds, disableRouterUpdates }) => {
  const { model: modelFromApi } = useModelContext();
  const editableModel = useEditableModel(modelFromApi, userAndAppIds);
  const [{ value: deploymentId }] = useField<PlaygroundConfig['deploymentId']>('deploymentId');
  const store = useUnsafePredictionStore<CF.API.Models.Model, IModelPredictionStoreMST>();

  // Sync the deploymentId from the formik field to the store
  // This is needed because the store is not aware of the formik field changes
  useEffect(() => {
    if (deploymentId) store?.viewState?.setDeploymentId(deploymentId || undefined);
  }, [deploymentId]);

  if (editableModel.data.model_version)
    return (
      <PredictionViewCore
        canvas={{
          RegionList: PredictionRegionList,
          mediaList: <PredictionMediaList editableEntity={editableModel} disableRouterUpdates={disableRouterUpdates} />,
        }}
      />
    );

  return null;
};
